export default __webpack_public_path__ + "static/media/Vector.275d0151.png";